import React, { useState } from 'react';
import Modal from 'react-modal';
import { PDFViewer } from '@react-pdf/renderer';
import Capacitacion_Certificado_PDF from './Capacitacion_Certificado_PDF';
import 'bootstrap/dist/css/bootstrap.min.css';
 
const styles = {
    modal: {
        top: '35%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        width: '60%',
        transform: 'translate(-40%, -10%)'      
    },
    pdf: {
        height: '95%',
        width: '100%'
    }
} 

    const Capacitacion_Certificado_PDF_Ventana = (props) => {
        const [modalPDFIsOpen, setModalPDFIsOpen] = useState(props.modalPDFIsOpen);   

        const handleModalPDF = () => {
            setModalPDFIsOpen(props.modalPDFIsOpen)   
        };

        const handleCerrarModalPDF = () => {
            props.handleAbrirPDF();
        };
    
        return (
            <Modal
                isOpen={modalPDFIsOpen}
                //onAfterOpen={afterOpenModal}
                onRequestClose={handleModalPDF}
                style={styles.modal}
                contentLabel="Impresion Certificado"
            >     
                    
                <PDFViewer style={styles.pdf}>
                    <Capacitacion_Certificado_PDF
                    nombre = {props.nombre}
                    />
                </PDFViewer>
                <button
                    onClick={handleCerrarModalPDF}
                    style={{float: 'right'}}
                >
                    Cerrar
                </button>
            </Modal>
        )
        
    }
    
    export default Capacitacion_Certificado_PDF_Ventana;